// extracted by mini-css-extract-plugin
export default {"container":"TypeConfigurator-module_container__k2bwI"};